import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[appClonedImage]'
  })
export class ClonedImageDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
